import { ObservableFromFetch } from "../ObservableFromFetch"
import RegulatoryMode from "./Model/RegulatoryMode"

export default function GetRegulatoryModeDonorByID(id: number | string) {
  return ObservableFromFetch<RegulatoryMode[]>(`FFOrderRegulatoryModeDonor/GetRegulatoryModeDonorByID?regulatoryModeID=${id}`)
}